/**
 * Google Drive monochrome outline mark (Finder / desktop sidebar style).
 * Source: Google Drive.app Contents/Resources/drive_logo_outline.svg
 */

import { forwardRef } from 'react';
import type { LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';

export const GoogleDriveIcon = forwardRef<SVGSVGElement, LucideProps>(function GoogleDriveIcon(
  { className, size, color, absoluteStrokeWidth: _absoluteStrokeWidth, strokeWidth: _strokeWidth, ...props },
  ref,
) {
  const dimension = typeof size === 'number' ? size : undefined;

  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      width={dimension}
      height={dimension}
      fill={color ?? 'currentColor'}
      className={cn('inline-block flex-shrink-0', className)}
      aria-hidden
      {...props}
    >
      <path d="M14.3 4L20.4 15L18.2999 19H5.69995L3.59995 15L9.69995 4H14.3ZM14.3 2H9.69995C8.99995 2 8.29995 2.4 7.99995 3L1.79995 14C1.49995 14.6 1.49995 15.3 1.79995 15.9L3.89995 19.9C4.29995 20.6 4.99995 21 5.69995 21H18.2999C18.9999 21 19.7 20.6 20.1 19.9L22.2 15.9C22.5 15.3 22.5 14.6 22.2 14L16.1 3C15.7 2.4 15 2 14.3 2Z" />
      <path d="M11.1 7.4L6.59995 15.2L7.29995 16.5H16.7999L17.5 15.2L12.9 7.4H11.1ZM9.29995 14.5L12 9.7L14.7 14.5H9.29995Z" />
    </svg>
  );
});

GoogleDriveIcon.displayName = 'GoogleDriveIcon';
